import { SvgIcon, SvgIconProps } from '@mui/material';

export default function Bolt({ ...props }: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <g id="zap">
        <path
          id="Icon"
          d="M10.8333 1.66406L2.5 11.6641H10L9.16667 18.3307L17.5 8.33073H10L10.8333 1.66406Z"
          stroke="#667085"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
